import React, { useState } from 'react';
import { useMutation } from '@apollo/client/react';
import { UPDATE_LOAD_STATUS } from '../../../graphql/client/mutations';
import { LoadStatusEdit, LoadStatusEditFields } from '../../../types/schemaTypes';
import { GET_LOAD_DETAIL, GET_LOAD_PROGRESS, GET_LOAD_LOGGERS } from '../../../graphql/client/queries';

const useMarkLoadComplete = (loadId: number, onClickHide: () => void, loadProgressData: any, loadDetail: any): any => {
    const [loadingErrorMessage, setLoadingErrorMessage] = useState('');
    const [loadedErrorMessage, setLoadedErrorMessage] = useState('');
    const [onSiteErrorMessage, setOnSiteErrorMessage] = useState('');
    const [deliveredErrorMessage, setDeliveredErrorMessage] = useState('');
    const [sandTicketImageErrorMessage, setSandTicketImageErrorMessage] = useState('');
    const [bolTicketImageErrorMessage, setBolTicketImageErrorMessage] = useState('');
    const [sandTicketNumberErrorMessage, setSandTicketNumberErrorMessage] = useState('');
    const [bolNumberErrorMessage, setBolNumberErrorMessage] = useState('');
    const [otherTicketNumberErrorMessage, setOtherTicketNumberErrorMessage] = useState('');
    const [weightErrorMessage, setWeightErrorMessage] = useState('');
    const [milesToWellErrorMessage, setMilesToWellErrorMessage] = useState('');
    const [statusErrorMessage, setStatusErrorMessage] = useState('');
    const [tmsIdErrorMessage, setTmsIdErrorMessage] = useState('');

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [showCompletedModal, setShowCompletedModal] = useState(false);
    const [showForbiddenModal, setShowForbiddenModal] = useState(false);
    const [updateLoadStatus] = useMutation(UPDATE_LOAD_STATUS, {
        onError: error => {
            if (error.message.includes('403: Forbidden')) {
                setShowForbiddenModal(true);
            } else {
                setShowErrorModal(true);
                setStatusErrorMessage('Load status has been updated by another user, please refresh.');
            }
        },
        onCompleted: () => {
            setShowCompletedModal(true);
        },
        refetchQueries: () => {
            return [
                {
                    query: GET_LOAD_DETAIL,
                    variables: { loadId: loadId },
                },
                {
                    query: GET_LOAD_PROGRESS,
                    variables: { loadId: loadId },
                },
                {
                    query: GET_LOAD_LOGGERS,
                    variables: {
                        input: {
                            loadId: loadId,
                            search: '',
                        },
                    },
                },
            ];
        },
    });

    const handleOnClickCancel = (): void => {
        setBolTicketImageErrorMessage('');
        setBolNumberErrorMessage('');
        setSandTicketImageErrorMessage('');
        setSandTicketNumberErrorMessage('');
        setOtherTicketNumberErrorMessage('');
        setWeightErrorMessage('');
        setMilesToWellErrorMessage('');
        setLoadingErrorMessage('');
        setLoadedErrorMessage('');
        setOnSiteErrorMessage('');
        setDeliveredErrorMessage('');
        setTmsIdErrorMessage('');
        setShowErrorModal(false);
        setShowCompletedModal(false);
        setShowForbiddenModal(false);

        if (statusErrorMessage) {
            window.location.reload();
        }
    };

    const checkForValidation = (): boolean => {
        if (loadProgressData.bolTicketImage === '' || loadProgressData.bolTicketImage === null) {
            setBolTicketImageErrorMessage('Bol Ticket Image');
        }
        if (loadProgressData.bolNumber === '' || loadProgressData.bolNumber === null) {
            setBolNumberErrorMessage('Bol Number');
        }
        if (loadProgressData.sandTicketImage === '' || loadProgressData.sandTicketImage === null) {
            setSandTicketImageErrorMessage('Sand Ticket Image');
        }
        if (loadProgressData.sandTicketNumber === '' || loadProgressData.sandTicketNumber === null) {
            setSandTicketNumberErrorMessage('Sand Ticket Number');
        }
        if (
            loadProgressData.additionalTicketImage !== '' &&
            loadProgressData.additionalTicketImage !== null &&
            (loadProgressData.additionalTicketNumber === null || loadProgressData.additionalTicketNumber === '')
        ) {
            setOtherTicketNumberErrorMessage('Additional Ticket Number');
        }
        if (
            loadProgressData.additionalTicketNumber !== '' &&
            loadProgressData.additionalTicketNumber !== null &&
            (loadProgressData.additionalTicketImage === null || loadProgressData.additionalTicketImage === '')
        ) {
            setOtherTicketNumberErrorMessage('Additional Ticket Image');
        }
        if (loadProgressData.weight === '' || loadProgressData.weight === null || loadProgressData.weight === 0) {
            setWeightErrorMessage('Weight');
        }
        if (loadProgressData.milesToWell === '' || loadProgressData.milesToWell === null) {
            setMilesToWellErrorMessage('Miles To Well');
        }
        if (loadProgressData.loadingDateTime === '' || loadProgressData.loadingDateTime === null) {
            setLoadingErrorMessage('At Loading Facility In');
        }
        if (loadProgressData.loadedDateTime === '' || loadProgressData.loadedDateTime === null) {
            setLoadedErrorMessage('At Loading Facility Out');
        }
        if (loadProgressData.onSiteDateTime === '' || loadProgressData.onSiteDateTime === null) {
            setOnSiteErrorMessage('At Destination In');
        }
        if (loadProgressData.deliveredDateTime === '' || loadProgressData.deliveredDateTime === null) {
            setDeliveredErrorMessage('At Destination Out');
        }
        if (
            (loadDetail.tmsId === '' || loadDetail.tmsId === null) &&
            (loadDetail.customerId === 46 || loadDetail.customerId === 6 || loadDetail.customerId === 85)
        ) {
            setTmsIdErrorMessage('Tms Id');
        }
        if (
            loadProgressData.bolTicketImage === '' ||
            loadProgressData.bolNumber === '' ||
            loadProgressData.sandTicketImage === '' ||
            loadProgressData.sandTicketNumber === '' ||
            loadProgressData.weight === '' ||
            loadProgressData.milesToWell === '' ||
            loadProgressData.loadingDateTime === '' ||
            loadProgressData.loadedDateTime === '' ||
            loadProgressData.onSiteDateTime === '' ||
            loadProgressData.deliveredDateTime === '' ||
            loadProgressData.bolTicketImage === null ||
            loadProgressData.bolNumber === null ||
            loadProgressData.sandTicketImage === null ||
            loadProgressData.sandTicketNumber === null ||
            loadProgressData.weight === null ||
            loadProgressData.weight === 0 ||
            loadProgressData.milesToWell === null ||
            loadProgressData.loadingDateTime === null ||
            loadProgressData.loadedDateTime === null ||
            loadProgressData.onSiteDateTime === null ||
            loadProgressData.deliveredDateTime === null ||
            (loadProgressData.additionalTicketImage !== '' &&
                loadProgressData.additionalTicketImage !== null &&
                (loadProgressData.additionalTicketNumber === '' || loadProgressData.additionalTicketNumber === null)) ||
            (loadProgressData.additionalTicketNumber !== '' &&
                loadProgressData.additionalTicketNumber !== null &&
                (loadProgressData.additionalTicketImage === '' || loadProgressData.additionalTicketImage === null)) ||
            ((loadDetail.tmsId === '' || loadDetail.tmsId === null) &&
                (loadDetail.customerId === 46 || loadDetail.customerId === 6 || loadDetail.customerId === 85))
        ) {
            return false;
        }
        return true;
    };

    const handleSubmit = (
        event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
    ): void => {
        if (event) {
            event.preventDefault();
        }
        if (!checkForValidation()) {
            setShowErrorModal(true);
        } else {
            const updateLoadStatusEditFields: LoadStatusEditFields = {
                newStatus: 'Completed',
            };
            const updateLoadStatusEdit: LoadStatusEdit = {
                loadId: loadId,
                loadStatusEdit: updateLoadStatusEditFields,
            };
            updateLoadStatus({
                variables: { input: updateLoadStatusEdit },
            });
        }
    };

    return {
        handleSubmit,
        showErrorModal,
        loadingErrorMessage,
        loadedErrorMessage,
        onSiteErrorMessage,
        deliveredErrorMessage,
        sandTicketImageErrorMessage,
        bolTicketImageErrorMessage,
        sandTicketNumberErrorMessage,
        bolNumberErrorMessage,
        weightErrorMessage,
        milesToWellErrorMessage,
        statusErrorMessage,
        handleOnClickCancel,
        showCompletedModal,
        showForbiddenModal,
        otherTicketNumberErrorMessage,
        tmsIdErrorMessage,
    };
};

export default useMarkLoadComplete;
